/**
 * Sends a browser on a legacy production host to `app.bowerlabs.ai` before
 * anything else boots. Imported FIRST in `main.tsx`: ES modules evaluate in
 * import order, so this runs before Firebase, analytics and React.
 *
 * CLIENT-SIDE ON PURPOSE. Do NOT replace this with a redirect in firebase.json
 * or the Firebase console keyed on `benenota-e6b50.web.app`. The edge load
 * balancer that serves `app.bowerlabs.ai` fetches the SPA from Firebase
 * Hosting with the Host header rewritten to `benenota-e6b50.web.app`
 * (`edge_app_hosting_origin` in infrastructure/terraform/envs/prod/main.tf,
 * modules/bower-env/edge-app.tf). A Hosting-level redirect on that host would
 * answer the edge's own fetch with a redirect to `app.bowerlabs.ai`, a loop,
 * and take production down. Here the redirect only ever sees the BROWSER's
 * hostname, which is `app.bowerlabs.ai` behind the edge.
 */
import { canonicalHostRedirectUrl } from './config/canonicalHost';
import { IS_PROD } from './config/env';

class CanonicalHostRedirectError extends Error {
  override name = 'CanonicalHostRedirectError';
}

const target = canonicalHostRedirectUrl(window.location, IS_PROD);
if (target) {
  window.location.replace(target);
  // Throwing aborts evaluation of every module imported after this one, so
  // the app never mounts on the wrong host while the navigation is in flight.
  throw new CanonicalHostRedirectError(
    `Leaving ${window.location.hostname} for the canonical host`,
  );
}
